import { NoticeInfo } from "../../../model/Notice";
import { ListResponse } from "../../../model/common/ListResponse";
import { axiosUtils } from "../../../network/axiosUtils";
import httpRequest from "../../../network/httpRequest";
import speedMateHttpRequest from "../../../network/speedMateHttpRequest";
import { HttpResponse } from "../../../network/types";

import { GetNoticeListRequest, PostNoticeSurveyReplyParams } from "./types";

const URL = "/repair-shop/notices";
export const getNoticeList = async (
  queryParams: GetNoticeListRequest
): Promise<ListResponse<NoticeInfo>> => {
  const url = `${URL}`;
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.GET,
    url,
    queryParams: { ...queryParams, viewable: true, service: "REPAIR_SHOP_WEB" },
  });
  return response?.data;
};
export const getNoticeDetail = async (id: number): Promise<NoticeInfo> => {
  const url = `${URL}/${id}`;
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.GET,
    url,
  });

  return response?.data.row;
};

/**
 * 설문조사 동의비동의
 * @param param0
 * @returns
 */
export const postNoticeSurveyReply = async ({
  id,
  acceptYn,
}: PostNoticeSurveyReplyParams) => {
  const url = `${URL}/${id}/survey/reply`;
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.POST,
    url,
    requestBody: { acceptYn },
  });

  return response?.data;
};

/**
 * 스피드메이트, 오토오아시스 용
 * @param queryParams
 * @returns
 */
export const getSpecialNoticeList = async (
  queryParams: GetNoticeListRequest
): Promise<ListResponse<NoticeInfo>> => {
  const url = `${URL}`;
  const response: HttpResponse = await speedMateHttpRequest({
    method: axiosUtils.GET,
    url,
    queryParams: { ...queryParams, viewable: true, service: "REPAIR_SHOP_WEB" },
  });
  return response?.data;
};
